"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DefaultGDGuidesSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _image = require("@site/pattern-library-core/image");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _panel = _interopRequireDefault(require("./common/panel.js"));
var _attribution = _interopRequireDefault(require("./common/attribution.js"));
var _styles = require("./common/styles.js");
const Container = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "Container",
  class: "pl-c1ym32n"
});
const TopContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TopContainer",
  class: "pl-tsjqz7d"
});

/**
 * Render Default GD Guides Section
 *
 * @param {Object} props React props
 * @param {boolean} props.invert Invert Color Props
 * @param {string} props.attribution Raw attribution text
 * @param {string} props.attributionPosition Attribution position
 * @param {Object} props.portrait Mobile background image
 * @param {Object} props.tabletPortraitBackground Tablet portrait background image
 * @param {Object} props.tablet Tablet portrait background image
 * @param {Object} props.landscape Desktop background image,
 * @param {string} props.verticalMargin Vertical Spacing value
 * @returns {React.ReactElement} Default GD Guides Section component
 * @public
 */
function DefaultGDGuidesSection({
  _name,
  invert,
  partial,
  attribution,
  attributionHeadline,
  attributionDescription,
  attributionPosition,
  portrait,
  tabletPortraitBackground,
  landscape,
  tablet,
  verticalMargin = 'none',
  ...otherProps
}) {
  const backgroundImages = {
    portrait: portrait?.url,
    tablet: tablet?.url || tabletPortraitBackground?.url,
    landscape: landscape?.url
  };
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    padding: "none",
    partial: partial || (invert ? 'dark1' : ''),
    verticalMargin: verticalMargin,
    dataCy: "gd-guides-section",
    _name: _name
  }, /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({}, backgroundImages, (0, _patternLibraryUtils.create)(_name, false, true)), /*#__PURE__*/_react.default.createElement(TopContainer, backgroundImages, (attribution || attributionHeadline || attributionDescription) && /*#__PURE__*/_react.default.createElement(_attribution.default, {
    attribution: attribution,
    attributionPosition: attributionPosition,
    attributionHeadline: attributionHeadline,
    attributionDescription: attributionDescription
  })), /*#__PURE__*/_react.default.createElement(_panel.default, (0, _extends2.default)({
    partial: partial || (invert ? 'dark1' : '')
  }, otherProps))));
}
DefaultGDGuidesSection.propTypes = {
  _name: _propTypes.default.string,
  portrait: _propTypes.default.shape(_image.imgPropShape),
  tabletPortraitBackground: _propTypes.default.shape(_image.imgPropShape),
  tablet: _propTypes.default.shape(_image.imgPropShape),
  landscape: _propTypes.default.shape(_image.imgPropShape),
  ..._panel.default.propTypes,
  ..._attribution.default.propTypes,
  ..._patternLibraryUtils.marginProps
};